import React, { useState } from 'react';

const MasterPage = () => {
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  
  // Sample master data
  const masterData = [
    { id: 1, title: 'Schemes' },
    { id: 2, title: 'Title of Event' },
    { id: 3, title: 'Clientele' }
  ];
  
  // Sample data for view modal (like in Image 3)
  const viewData = [
    { id: 1, name: 'PMKVY', code: 'SC001', details: 'Pradhan Mantri Kaushal Vikas Yojana' },
    { id: 2, name: 'DDU-GKY', code: 'SC002', details: 'Deen Dayal Upadhyaya Grameen Kaushalya Yojana' },
    { id: 3, name: 'NULM', code: 'SC003', details: 'National Urban Livelihoods Mission' }
  ];
  
  // Handle opening the View modal
  const handleView = (item) => {
    setCurrentItem(item);
    setIsViewModalOpen(true);
  };
  
  // Handle opening the Add modal
  const handleAdd = (item) => {
    setCurrentItem(item);
    setIsAddModalOpen(true);
  };
  
  // Close modals
  const closeViewModal = () => {
    setIsViewModalOpen(false);
  };
  
  const closeAddModal = () => {
    setIsAddModalOpen(false);
  };
  
  // Modal for adding new items (like in Image 2)
  const AddModal = () => {
    const [formData, setFormData] = useState({
      name: '',
      code: '',
      details: ''
    });
    
    const handleChange = (e) => {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value
      });
    };
    
    const handleSubmit = (e) => {
      e.preventDefault();
      console.log('Form submitted:', formData);
      closeAddModal();
    };
    
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
        <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold text-orange-500">Add {currentItem?.title}</h2>
            <button onClick={closeAddModal} className="text-gray-500 hover:text-gray-700">
              ✕
            </button>
          </div>
          
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-gray-700 font-semibold mb-2">
                Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full border border-gray-300 p-2 rounded-lg"
                required
              />
            </div>
            
            <div className="mb-4">
              <label className="block text-gray-700 font-semibold mb-2">
                Code <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="code"
                value={formData.code}
                onChange={handleChange}
                className="w-full border border-gray-300 p-2 rounded-lg"
                required
              />
            </div>
            
            <div className="mb-4">
              <label className="block text-gray-700 font-semibold mb-2">
                Details <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="details"
                value={formData.details}
                onChange={handleChange}
                className="w-full border border-gray-300 p-2 rounded-lg"
                required
              />
            </div>
            
            <div className="flex justify-end mt-6 space-x-2">
              <button
                type="button"
                onClick={closeAddModal}
                className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  };
  
  // Modal for viewing items (like in Image 3)
  const ViewModal = () => {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
        <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-4xl">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold text-orange-500">{currentItem?.title} Details</h2>
            <button onClick={closeViewModal} className="text-gray-500 hover:text-gray-700">
              ✕
            </button>
          </div>
          
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-blue-100">
                <tr>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-800">#</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-800">Name</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-800">Code</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-800">Details</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-800">Action</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {viewData.map((item, index) => (
                  <tr key={item.id}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{index + 1}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{item.name}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{item.code}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{item.details}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                      <button className="px-4 py-1 bg-blue-500 text-white rounded-md hover:bg-blue-600">
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
          <div className="flex justify-end mt-6">
            <button
              onClick={closeViewModal}
              className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  };
  
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold text-blue-500 mb-6">Master Creation</h1>
      
      <div className="overflow-x-auto bg-white rounded-lg shadow">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-blue-100">
            <tr>
              <th scope="col" className="px-6 py-3 text-left text-sm font-semibold text-gray-800 w-16">
                #
              </th>
              <th scope="col" className="px-6 py-3 text-left text-sm font-semibold text-gray-800">
                Master Title
              </th>
              <th scope="col" className="px-6 py-3 text-right text-sm font-semibold text-gray-800 w-64">
                Action
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {masterData.map((item, index) => (
              <tr key={item.id}>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  {index + 1}.
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 font-medium">
                  {item.title}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                  <div className="flex justify-end space-x-2">
                    <button
                      onClick={() => handleAdd(item)}
                      className="px-4 py-2 bg-green-500 text-white font-medium rounded hover:bg-green-600 transition-colors"
                    >
                      Add
                    </button>
                    <button
                      onClick={() => handleView(item)}
                      className="px-4 py-2 bg-blue-500 text-white font-medium rounded hover:bg-blue-600 transition-colors"
                    >
                      View
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      {isAddModalOpen && <AddModal />}
      {isViewModalOpen && <ViewModal />}
    </div>
  );
};

export default MasterPage;